import { fetchAuthSession } from "aws-amplify/auth";
import { appConfig } from "@/app/config";

export class BaseService {
  protected static async getAuthToken(): Promise<string | undefined> {
    const session = await fetchAuthSession();
    return session.tokens?.idToken?.toString();
  }

  protected static async makeRequest(
    endpoint: string,
    options: RequestInit = {}
  ): Promise<Response> {
    const token = await this.getAuthToken();
    const baseUrl = appConfig.api.baseUrl;

    if (!baseUrl) {
      throw new Error("API Gateway URL not configured");
    }

    const headers: Record<string, string> = {
      "Content-Type": "application/json",
      ...(options.headers as Record<string, string> || {}),
    };

    if (token) {
      headers["Authorization"] = token;
    }

    const url = `${baseUrl}${endpoint}`;
    
    return fetch(url, {
      ...options,
      headers,
    });
  }

  protected static async get(endpoint: string): Promise<Response> {
    return this.makeRequest(endpoint, {
      method: "GET",
    });
  }

  protected static async post(
    endpoint: string,
    data: unknown
  ): Promise<Response> {
    return this.makeRequest(endpoint, {
      method: "POST",
      body: JSON.stringify(data),
    });
  }

  protected static async put(
    endpoint: string,
    data: unknown
  ): Promise<Response> {
    return this.makeRequest(endpoint, {
      method: "PUT",
      body: JSON.stringify(data),
    });
  }

  protected static async delete(endpoint: string): Promise<Response> {
    return this.makeRequest(endpoint, {
      method: "DELETE",
    });
  }

  protected static async handleResponse<T>(response: Response): Promise<T> {
    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(
        `API Error ${response.status}: ${errorText || response.statusText}`
      );
    }

    const text = await response.text();
    return text ? JSON.parse(text) : ({} as T);
  }
}